import React from 'react';
import { Modal, Table, Tag } from 'antd';
import { ApprovalHistory } from '../../../services/j203Api';

interface Props {
  visible: boolean;
  onClose: () => void;
  data: ApprovalHistory[];
}

const actionLabel = (action: string): { text: string; color: string } => {
  switch (action) {
    case 'SUBMIT': return { text: '送審', color: 'blue' };
    case 'APPROVE': return { text: '核准', color: 'green' };
    case 'REJECT': return { text: '退回', color: 'red' };
    default: return { text: action, color: 'default' };
  }
};

const columns = [
  {
    title: '#', dataIndex: 'id', key: 'id', width: 50,
  },
  {
    title: '動作', dataIndex: 'action', key: 'action', width: 80,
    render: (v: string) => {
      const a = actionLabel(v);
      return <Tag color={a.color}>{a.text}</Tag>;
    },
  },
  { title: '執行人', dataIndex: 'actor_name', key: 'actor_name', width: 100 },
  { title: '備註', dataIndex: 'comment', key: 'comment' },
  {
    title: '狀態變更', key: 'status', width: 120,
    render: (_: unknown, r: ApprovalHistory) => `${r.old_status} → ${r.new_status}`,
  },
  {
    title: '時間', dataIndex: 'created_at', key: 'created_at', width: 160,
    render: (v: string) => v ? new Date(v).toLocaleString('zh-TW') : '',
  },
];

const ApprovalHistoryModal: React.FC<Props> = ({ visible, onClose, data }) => (
  <Modal
    title="審核歷史"
    open={visible}
    onCancel={onClose}
    footer={null}
    width={720}
  >
    <Table
      dataSource={data}
      columns={columns}
      rowKey="id"
      size="small"
      pagination={false}
    />
  </Modal>
);

export default React.memo(ApprovalHistoryModal);
